import 'react-app-polyfill/ie11'
import 'react-app-polyfill/stable'
import React from 'react'
import ReactDOM from 'react-dom'
import App from './components/App'
import { IntlProvider } from 'react-intl'
import English from './translate/en.json'
import Japanese from './translate/ja.json'

const locale = navigator.language
let lang = Japanese
if (locale === 'en') {
    lang = English
} else {
    lang = Japanese
}

ReactDOM.render(
    <IntlProvider locale={ locale } messages={ lang }>
        <App />
    </IntlProvider>, document.getElementById('root'))
